export type Viseme = {
    time: number;
    duration: number;
    weights: Record<string, number>;
};
export class LipSyncController {
    timeline: Viseme[] = [];
    at(time: number) { const out: Record<string, number> = {}; for (const v of this.timeline) {
        const t = (time - v.time) / v.duration;
        if (t >= 0 && t <= 1) {
            const envelope = Math.sin(Math.PI * t);
            for (const [n, w] of Object.entries(v.weights))
                out[n] = (out[n] ?? 0) + w * envelope;
        }
    } return out; }
    approximate(time: number) { return .18 + .58 * Math.pow(Math.max(0, Math.sin(time * 13.3) + .35 * Math.sin(time * 21.7)), .65); }
}
